export default (remote) => ({
    get: (page) => {
        // if (process.server) {
        //     return JSON.parse(require('fs')
        //         .readFileSync(`../../static/content/${ process.lang.substr(0, 2) }/${ page }.json`, 'utf8'));
        // }
        return remote.get(`${ page }.json`);
    }
});
